import styled from 'styled-components'
import { NEUTRAL_100, WHITE } from '../../styles/colors'

export const Container = styled.div`
  background-color: ${WHITE};
  border-radius: 16px;
  border: 1px solid ${NEUTRAL_100};
  padding: 20px 16px 24px 16px;
`

interface GridProps {
  $columns: number
}

export const Grid = styled.div<GridProps>`
  display: grid;
  grid-template-columns: repeat(${props => props.$columns}, 1fr);
  justify-content: center;
  justify-items: center;
  gap: 16px;
  width: 100%;
`
